export const toNumber = (value) => {
  if (value == null || value === '') return NaN;
  if (typeof value === 'number') return value;
  const num = Number(String(value).replace(/[₹,\s]/g, ''));
  return num;
};

export const formatNumber = (value) => {
  const num = toNumber(value);
  if (!Number.isFinite(num)) return value == null || value === '' ? '—' : String(value);
  return num.toLocaleString('en-IN');
};

export const formatAmount = (value) => {
  const num = toNumber(value);
  if (!Number.isFinite(num)) {
    const raw = String(value || '').trim();
    if (!raw) return '—';
    if (raw.startsWith('₹')) return raw;
    return `₹${raw}`;
  }
  return `₹${num.toLocaleString('en-IN')}`;
};

export const isInvoiceReceived = (value) => {
  if (value === true || value === 1) return true;
  const text = String(value ?? '').trim().toLowerCase();
  if (!text || text === 'required' || text === 'pending' || text === 'false' || text === '0') {
    return false;
  }
  return text === 'received' || text === 'uploaded' || text === 'complete' || text === 'true';
};
